import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { appointmentService } from '../services/appointmentService';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { FaCalendar, FaClock, FaUser, FaCheckCircle, FaClock as FaPending, FaTimesCircle } from 'react-icons/fa';
import './MyAppointments.css';

const MyAppointments = () => {
  const { data: appointments, isLoading, refetch } = useQuery(
    'myAppointments',
    () => appointmentService.getMyAppointments()
  );

  const handleCancelAppointment = async (id) => {
    if (!window.confirm('Are you sure you want to cancel this appointment?')) return;
    
    try {
      await appointmentService.cancelAppointment(id);
      toast.success('Appointment cancelled successfully');
      refetch();
    } catch (error) {
      toast.error('Failed to cancel appointment');
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      pending: { icon: FaPending, class: 'status-pending', label: 'Pending' },
      confirmed: { icon: FaCheckCircle, class: 'status-confirmed', label: 'Confirmed' },
      cancelled: { icon: FaTimesCircle, class: 'status-cancelled', label: 'Cancelled' },
      completed: { icon: FaCheckCircle, class: 'status-completed', label: 'Completed' },
    };

    const config = statusConfig[status] || statusConfig.pending;
    const Icon = config.icon;

    return (
      <span className={`status-badge ${config.class}`}>
        <Icon /> {config.label}
      </span>
    );
  };

  if (isLoading) {
    return (
      <div className="spinner-wrapper">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="my-appointments-page">
      <div className="page-header">
        <div className="container">
          <h1>My Appointments</h1>
          <p>Manage your medical appointments</p>
        </div>
      </div>

      <div className="container">
        <div className="appointments-wrapper">
          {!appointments?.data || appointments.data.length === 0 ? (
            <div className="no-appointments">
              <p>You don't have any appointments yet.</p>
              <a href="/book-appointment" className="btn btn-primary">Book Your First Appointment</a>
            </div>
          ) : (
            <div className="appointments-grid">
              {appointments.data.map((appointment) => (
                <div key={appointment.id} className="appointment-card">
                  <div className="appointment-header">
                    <div className="doctor-info">
                      <h3>Dr. {appointment.doctor?.name}</h3>
                      <p>{appointment.doctor?.specialization}</p>
                    </div>
                    {getStatusBadge(appointment.status)}
                  </div>

                  <div className="appointment-details">
                    <div className="detail-item">
                      <FaCalendar />
                      <span>{format(new Date(appointment.appointment_date), 'MMMM dd, yyyy')}</span>
                    </div>
                    <div className="detail-item">
                      <FaClock />
                      <span>{appointment.time_slot}</span>
                    </div>
                    <div className="detail-item">
                      <FaUser />
                      <span>{appointment.department?.name}</span>
                    </div>
                  </div>

                  {appointment.symptoms && (
                    <div className="appointment-symptoms">
                      <strong>Symptoms:</strong> {appointment.symptoms}
                    </div>
                  )}

                  {appointment.notes && (
                    <div className="appointment-notes">
                      <strong>Notes:</strong> {appointment.notes}
                    </div>
                  )}

                  <div className="appointment-footer">
                    <div className="consultation-fee">
                      Fee: ₹{appointment.consultation_fee}
                    </div>
                    {appointment.status === 'pending' || appointment.status === 'confirmed' ? (
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleCancelAppointment(appointment.id)}
                      >
                        Cancel Appointment
                      </button>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyAppointments;
